@if (element.isSyncingEnabled || !element.locked) {
  <div class="sync-row-cell">
    <i class="material-icons sync-icon {{ getIconClassForStyle(element.syncInfo?.style) }}">
      {{ element.syncInfo.icon }}
    </i>
    <span
      class="synced-text {{ getTextClassForStyle(element.syncInfo?.style) }}"
      [glxyTooltip]="element?.syncInfo?.tooltip"
      [tooltipTitle]="element?.syncInfo?.tooltipTitle"
      [highContrast]="false"
    >
      {{ element.syncInfo.text }}
    </span>
  </div>
} @else {
  <button mat-icon-button color="basic" (click)="openUpgradeDialog()">
    <mat-icon class="ugprade-to-pro-lock-icon">lock</mat-icon>
  </button>
}
